import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// ─── Chunk-load error auto-recovery ────────────────────────────────────────
// When a new build is deployed, users who have the previous index.html cached
// will try to fetch chunks with the OLD content-hash filenames (e.g. "934.9fc….chunk.js")
// which no longer exist on the server → ChunkLoadError. Auto-recover by reloading
// the page once (with a query-string cache-buster). We persist a flag in
// sessionStorage so we never loop more than once.
function isChunkLoadError(err) {
  if (!err) return false;
  const msg = (err.message || err.toString() || '').toLowerCase();
  return (
    msg.includes('loading chunk') ||
    msg.includes('loading css chunk') ||
    err.name === 'ChunkLoadError' ||
    msg.includes('failed to fetch dynamically imported module')
  );
}
function handleChunkError(err) {
  if (!isChunkLoadError(err)) return;
  try {
    const already = sessionStorage.getItem('__wh_chunk_reload');
    if (already) return; // Don't loop
    sessionStorage.setItem('__wh_chunk_reload', String(Date.now()));
  } catch { /* sessionStorage may be unavailable */ }
  // Force-reload bypassing the HTTP cache.
  const url = new URL(window.location.href);
  url.searchParams.set('_cb', Date.now().toString());
  window.location.replace(url.toString());
}
window.addEventListener('error', (e) => handleChunkError(e.error || e));
window.addEventListener('unhandledrejection', (e) => handleChunkError(e.reason));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
